import { Stack, Typography } from '@mui/material';

import { COLORS } from '@/styles/tokens/colors';

import { useSalesforceBrand } from './brand';
import type { SalesforceFormMapping } from './formMapping';
import type { SalesforceObjectDescription } from './metadata';
import { WEALTHHUB_TRUST_REVIEW_OBJECT } from './metadata';

export function SalesforceDestinationBanner({
  mapping,
  description,
}: {
  mapping: SalesforceFormMapping;
  description?: SalesforceObjectDescription;
}) {
  const brand = useSalesforceBrand();
  const objectLabel = description?.label ?? mapping.objectAPIName;
  const lookupLabel =
    description?.fields.find(
      (field) => field.apiName === mapping.householdLookup.fieldAPIName
    )?.label ?? mapping.householdLookup.fieldAPIName;

  return (
    <Stack
      component="section"
      aria-label={`${brand.name} destination`}
      direction={{ xs: 'column', md: 'row' }}
      alignItems={{ xs: 'flex-start', md: 'center' }}
      justifyContent="space-between"
      gap={1}
      px={2}
      py={1}
      bgcolor={COLORS.GRAY[50]}
      borderBottom={`1px solid ${COLORS.GRAY[200]}`}
    >
      <Stack minWidth={0}>
        <Typography variant="title-xs">Exports to {objectLabel}</Typography>
        <Typography
          variant="body-xs"
          sx={{ color: COLORS.TEXT.SECONDARY, overflowWrap: 'anywhere' }}
        >
          {mapping.objectAPIName === WEALTHHUB_TRUST_REVIEW_OBJECT
            ? 'Choose the Household or Family and optional Trust legal entity at export time.'
            : `Links each household through ${lookupLabel}.`}
        </Typography>
      </Stack>
      {!description && (
        <Typography
          role="status"
          variant="body-xs"
          sx={{ color: COLORS.TEXT.SECONDARY }}
        >
          Loading current {brand.name} metadata…
        </Typography>
      )}
    </Stack>
  );
}
